
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Eye, EyeOff, ChevronDown } from "lucide-react";
import styles from './LoginPage.module.css';
import googlesymbol from "../../Images/googlesymbol.png";
import loginImage from "../../assets/login-IMG.jpeg";
import executiveimage from "../../Images/executiveimage.png";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("user");
  const [toast, setToast] = useState({ message: "", type: "", visible: false });
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [roleSelected, setRoleSelected] = useState(false);
  const navigate = useNavigate();

  const handleEmailChange = (e) => setEmail(e.target.value);
  const handlePasswordChange = (e) => setPassword(e.target.value);
  // const handleRoleChange = (e) => setRole(e.target.value);
  const handleRoleChange = (newRole) => {
    console.log("Role changing to:", newRole);
    setRole(newRole);
    setRoleSelected(true);
    setIsDropdownOpen(false);
  };
  const togglePasswordVisibility = () => setShowPassword(!showPassword)

  const showToast = (message, type) => {
    setToast({ message, type, visible: true });
    setTimeout(() => setToast({ message: "", type: "", visible: false }), 3000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      showToast("Please fill all fields.", "error");
      return;
    }

    let endpoint = "";
    let redirectPath = "/dashboard";

    switch (role) {
      case "user":
      case "qa":
        endpoint = `${process.env.REACT_APP_SERVER_API}/api/login`;
        redirectPath = "/executive-dashboard";
        break;
      case "admin":
        endpoint = `${process.env.REACT_APP_SERVER_API}/api/login`;
        redirectPath = "/admin-dashboard";
        break;
      case "executive":
        endpoint = `${process.env.REACT_APP_SERVER_API}/api/executive/login`;
        redirectPath = "/executive-dashboard";
        break;
      default:
        showToast("Invalid role selected.", "error");
        return;
    }

    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = await response.json();

      if (response.ok) {
        const userRole = data.user.role; // Use backend-assigned role
        showToast("Login successful!", "success");

        // Set localStorage based on backend response
        localStorage.setItem("user", JSON.stringify(data.user));
        localStorage.setItem("isLoggedIn", "true");
        localStorage.setItem("role", userRole);

        // Redirect based on backend role (extra safety)
        if (userRole === "admin") {
          redirectPath = "/admin-dashboard";
        } else if (userRole === "executive") {
          redirectPath = "/executive-dashboard";

        } else if (userRole === "qa") {
          redirectPath = "/recordingdashboard";
        }
        else if (userRole === "user") {
          // Fetch intro status for "user" role
          try {
            const introResponse = await fetch(`${process.env.REACT_APP_SERVER_API}/api/intro-data/${data.user.id}`);
            const introData = await introResponse.json();
            if (introResponse.ok && introData.introData.introCompleted) {
              redirectPath = "/dashboard";
            } else {
              redirectPath = "/get-started";
            }
          } catch (introError) {
            console.error("Error fetching intro status:", introError);
            redirectPath = "/get-started";
          }
        }


        // Check if selected role matches backend role for non-admins
        if (!email.includes("admin") && role !== userRole) {
          setIsLoading(false);
          showToast("Error: Please select the correct role.", "error");
          return;
        }

        setTimeout(() => {
          setIsLoading(false);
          navigate(redirectPath);
        }, 1000);

      } else {
        showToast(data.error || "Login failed.", "error");
      }

    } catch (error) {
      console.error("Error during login:", error);
      showToast("An error occurred. Please try again.", "error");
    }
  };

  const handleGoogleSignIn = () => {
    console.log("Continue with Google");
  };

  const handleSignUpNavigation = (selectedRole) => {
    console.log("Navigating to signup for role:", selectedRole);
    navigate(`/signup?role=${selectedRole}`);
    setIsDropdownOpen(false);
  };

  const buttonText = roleSelected ? role.charAt(0).toUpperCase() + role.slice(1) : "Sign Up";

  const handleForgotPassword = () => {
    navigate("/forgot-password");
  };


  const toastStyles = {
    position: "fixed",
    top: "100px",
    left: "50%",
    transform: "translateX(-50%)",
    padding: "10px 20px",
    borderRadius: "5px",
    color: "white",
    fontWeight: "bold",
    zIndex: 1000,
    animation: "fadeInOut 3s ease-in-out",
    backgroundColor: toast.type === "success" ? "#28a745" : "#dc3545",
  };
  const keyframes = `
    @keyframes fadeInOut {
      0% { opacity: 0; }
      10% { opacity: 1; }
      90% { opacity: 1; }
      100% { opacity: 0; }
    }
  `;

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <header className="bg-blue-600 text-white p-4 flex justify-between items-center" >
        <h1 className="text-5xl font-bold">Ryngmo!</h1>
        <div className="relative">
          {/* <select
            id="signUpRole"
            className="bg-gray-200 text-black px-7 py-2 rounded-lg border border-blue-500 focus:outline-none focus:ring-2  appearance-none cursor-pointer"
            value="Sign Up" 
            onChange={handleRoleChange}
            style={{fontSize:'18px'}}
          >
            <option value="Sign Up" disabled hidden >Sign Up</option>
            <option value="user">User</option>
            <option value="executive">Executive</option>
            <option value="qa">QA</option>
          </select>
          <ChevronDown className="absolute right-2 top-1/2 -translate-y-1/2 text-black pointer-events-none w-6 h-4 " 
          strokeWidth={4.0}/>
        </div>
      </header> */}
          <button
            className="bg-gray-200 text-black px-6 py-3 rounded-lg border border-blue-500 focus:outline-none focus:ring-2 flex items-center justify-between w-40"
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          >
            {/* <span style={{fontSize:'18px'}}>{buttonText}</span> */}
            <span style={{ fontSize: '18px' }}>{buttonText}</span>
            <ChevronDown className="ml-2 text-black pointer-events-none w-6 h-4" strokeWidth={4.0} />
          </button>
          {isDropdownOpen && (
            <div className="absolute right-0 mt-2 w-40 bg-white border border-gray-300 rounded-lg shadow-lg z-10">
              <button
                className="w-full text-left px-4 py-2 text-black hover:bg-gray-100"
                onClick={() => handleRoleChange("user")}
              >
                User
              </button>
              <button
                className="w-full text-left px-4 py-2 text-black hover:bg-gray-100"
                onClick={() => handleRoleChange("executive")}
              >
                Executive
              </button>
              <button
                className="w-full text-left px-4 py-2 text-black hover:bg-gray-100"
                onClick={() => handleRoleChange("qa")}
              >
                QA
              </button>
            </div>
          )}
        </div>
      </header>

      {/* Main Content */}
      <div className="flex-1 flex items-center justify-center p-4">
        <div className="w-full max-w-8xl flex flex-col md:flex-row items-center justify-center gap-12">
          {/* Loader Overlay */}
          {isLoading && (
            <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-50">
              <div className="relative">
                <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                <div className="absolute inset-0 w-16 h-16 border-4 border-blue-300 border-t-transparent rounded-full animate-spin animate-reverse"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="text-white text-sm font-medium animate-pulse">Loading QA...</span>
                </div>
              </div>
            </div>
          )}

          <div className="w-full md:w-2/6">
            <div className="flex flex-col h-full pt-6 pb-6">
              <h2 className="text-3xl font-bold mb-2">Sign In</h2>
              <h4 className="text-gray-500 mb-6 font-bold ">Login to your Ryngmo account here</h4>

              <button
                onClick={handleGoogleSignIn}
                className="w-full flex items-center justify-center border border-gray-300 text-gray-700 py-2 rounded-lg hover:bg-gray-50 transition-colors"
              >
                <img src={googlesymbol} alt="Google" className="w-8 h-6 mr-2" />
                Google
              </button>

              <div className="flex items-center my-4">
                <div className="flex-grow h-px bg-gray-300"></div>
                <span className="px-3 text-gray-500 text-sm">OR CONTINUE WITH</span>
                <div className="flex-grow h-px bg-gray-300"></div>
              </div>

              <form onSubmit={handleSubmit} className="space-y-4 flex-1">
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                  <input
                    type="email"
                    id="email"
                    className="w-full px-3 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all bg-blue-50"
                    value={email}
                    onChange={handleEmailChange}
                    placeholder="Email address"
                  />
                </div>

                <div>
                  <div className="relative display-flex">
                    <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">Password</label>
                    <label htmlFor="password" className="absolute right-2 top-1/2 -translate-y-1/2 text-sm text-blue-600 hover:underline cursor-pointer"
                      onClick={handleForgotPassword}>Forgot your password?</label>
                  </div>
                  <div className="relative">

                    <input
                      type={showPassword ? "text" : "password"}
                      id="password"
                      className="w-full px-3 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all bg-blue-50"
                      value={password}
                      onChange={handlePasswordChange}
                      placeholder="Password"
                    />
                    <button
                      type="button"
                      onClick={togglePasswordVisibility}
                      className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                    >
                      {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                    </button>

                  </div>

                </div>

                {/* Role selection only for non-admins */}
                {/* {!email.includes("admin") && (
                  <div>
                    <label htmlFor="role" className="block text-sm font-medium text-gray-700 mb-1">Role</label>
                    <div className="relative">
                      <select
                        id="role"
                        className="w-full px-3 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all appearance-none bg-blue-50 cursor-pointer"
                        value={role}
                        onChange={handleRoleChange}
                      >
                        <option value="user">User</option>
                        <option value="executive">Executive</option>
                        <option value="qa">QA</option>
                      </select>
                      <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 pointer-events-none w-4 h-4" />
                    </div>
                  </div>
                )} */}

                <button
                  type="submit"
                  className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition-colors font-medium disabled:bg-blue-400"
                  disabled={isLoading}
                >
                  {isLoading ? "LOADING..." : "LOGIN"}
                </button>

                <div className="text-right mt-4">
                  <span className="text-sm text-gray-600 font-bold">New here? </span>
                  <a
                    href="/signup"
                    className="text-sm text-blue-600 hover:underline"
                  >
                    Create an account
                  </a>
                </div>

              </form>
            </div>
          </div>

          <div className="w-full md:w-5/12 flex items-center justify-center">
            <div className="w-full max-w-lg">
              <img
                src={executiveimage}
                alt="Login Illustration"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>

        </div>
      </div>

      {/* Toast Notification */}
      {toast.visible && (
        <div
          className={`fixed top-10 left-1/2 -translate-x-1/2 px-6 py-3 rounded-lg text-white font-medium animate-fade-in-out ${toast.type === "success" ? "bg-green-500" : "bg-red-500"
            }`}
        >
          {toast.message}
        </div>
      )}

      <footer className="bg-blue-600 h-10 w-full"></footer>

      {/* Custom Animation for Toast */}
      <style jsx global>{`
        @keyframes fade-in-out {
          0% { opacity: 0; transform: translateY(-10px); }
          10% { opacity: 1; transform: translateY(0); }
          90% { opacity: 1; transform: translateY(0); }
          100% { opacity: 0; transform: translateY(-10px); }
        }
        .animate-fade-in-out {
          animation: fade-in-out 3s ease-in-out;
        }
        .animate-reverse {
          animation-direction: reverse;
        }
      `}</style>
    </div>
  );
};

export default LoginPage;

